var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsFunnelTrafficMessenger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "6f7nran95a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#006AFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    x: -0.059,
    y: -0.059,
    fill: "url(#6f7nran95a)",
    rx: 32
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 9C15.748 9 9 15.48 9 23.516c0 4.393 2.043 8.294 5.217 10.95V40.5l.958-.527 4.708-2.532c1.315.364 2.683.59 4.117.59 8.252 0 15-6.48 15-14.515C39 15.48 32.252 9 24 9zm0 1.35c7.594 0 13.696 5.913 13.696 13.166 0 7.252-6.102 13.165-13.696 13.165-1.411 0-2.777-.21-4.056-.59l-.244-.064-.224.127-3.954 2.13v-4.43l-.245-.19c-3.042-2.424-4.973-6.071-4.973-10.148 0-7.253 6.102-13.166 13.696-13.166zm-1.488 9.263l-7.846 8.608 7.051-4.093 3.77 4.177 7.745-8.692-6.868 3.987-3.852-3.987z",
    transform: "translate(8 8)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsFunnelTrafficMessenger);
export default __webpack_public_path__ + "static/media/illustrations-funnel-traffic-messenger.beea7b8c.svg";
export { ForwardRef as ReactComponent };